import { Component, Input, ElementRef, Inject } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcComponent } from '../fc';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
/**
 * fc-fastpositionå¿«éå®ä½
 * 
 * å¿«éå®ä½ç»ä»¶ã
 * 
 * æ ¹æ®éç¹ï¼ç¹å»è°å°æå®ä½ç½®ã
 * 
 * äºä»¶ï¼
 * 
 * 1.éä¸­äºä»¶ï¼selected
 * 
 */
@Component({
    selector: 'fc-fastposition',
    template: `
    <div class="fc-fastposition">
        <i class="fc-fastposition-toggle icon iconfont fc-icon-pack" [ngClass]="{'fc-icon-pack':fcOpen,'fc-icon-unfold':!fcOpen}" (click)="_toggle($event)"></i>
        <nz-affix [ngClass]="{'fc-fastposition-open':fcOpen,'fc-fastposition-close':!fcOpen}">
            <nz-anchor style="width:100px;">
                <nz-link *ngFor="let link of fcLinks" (click)="_toAnchor(link.href,100);_select(link)"  [ngClass]="{active:_isActive(link)}">
                    <nz-template>
                        <span [title]="link.label">{{link.label.length>4?link.label.substr(0,4):link.label}}</span>
                    </nz-template>
                </nz-link>
            </nz-anchor>
        </nz-affix>
    </div>
    `,
    styles: [`
        :host ::ng-deep .fc-fastposition nz-anchor {
            display: block;
            width: 100px;
        }
        :host ::ng-deep .ant-anchor-wrapper{
            background: transparent;
            text-align:left;
        }
        :host ::ng-deep .ant-anchor-link{
            height: 30px;
            font-size: 14px;
            color: #333333;
            padding:0px;
            cursor: pointer;
            margin-left:20px;
        }
        :host ::ng-deep .ant-anchor-ink{
            left:16px;
        }
        .fc-fastposition-open{
            display:block;
        }
        .fc-fastposition-close{
            display:none;
        }
        .fc-fastposition-toggle{
            width: 45px;
            text-align: center;
            margin-bottom: 10px;
            color: #108ee9;
            position: absolute;
            right: 10px;
            top:-20px;
            font-size: 20px;
            cursor: pointer;
            z-index:99;
        }
        .fc-fastposition {
            position: fixed;
            right: 0px;
        }
        .fc-anchorshow{
            color:red;
        }
        .fastposition-color{
            color:red;
        }
        .active{
            color:#1890FF;
        }
    `]
})
export class FcfastpositionComponent extends FcComponent {
    /** æ é¢*/
    @Input()
    fcTitle: string;
    /** è·é¡¶é¨è§¦å*/
    @Input()
    fcOffsetTop: number;
    /** è¾¹ç*/
    @Input()
    fcBounds: number; /**5px*/
    /** å³èå³ç³»*/
    @Input()
    fcAppLinks: any[];
    /** é¾æ¥*/
    @Input()
    fcLinks: FcfastpositionOption[];
    /**èæ¯é¢è²*/
    @Input()
    fcBgcolor: string;
    private doc: Document;
    /**å±éæ¶èµ·*/
    @Input()
    fcOpen: boolean = true;
    /**ç¹å»éä¸­*/
    @Input()
    fcSelected: string;
    constructor(public provider: ProvidersService, public elementRef: ElementRef, @Inject(DOCUMENT) doc: any, public router: Router) {
        super(provider, 'fc-fastposition');
        this.doc = doc;
        if (this.fcOpen === undefined) {
            this.fcOpen = true;
        }
    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
        if (this.fcLinks === undefined) {
            throw new Error("labelåhrefå¿é¡»ä¼ å¥");
        }
    }
    ngAfterViewInit() {  /** æ¨¡æ¿ä¸­çåç´ å·²åå»ºå®æ*/
        let target = this.doc.querySelector('.content-main');
    }
    /**
     * 
     * @param item éä¸­Id
     */
    _select(item) {
        this.fcSelected = item;
        this.event( "selected",item)
    };
    /**
     * 
     * @param item ç¹å»Id
     */
    _isActive(item) {
        return this.fcSelected === item;
    };
    /**
     * æ»å¨éç¹
     *
     * @param   location åç´ id
     * @param   wait  ç­å¾æ¯«ç§æ°
     */
    _toAnchor(location: string, wait:number): void {
        if(wait===undefined || wait == null){
            wait = 200;
        }
        const element = document.querySelector('#' + location)
        if (element) {
            setTimeout(() => {
                element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
            }, wait)
        }
    }
    /**
     * å±å¼
     * 
     * @param  
     */
    _toggle($event) {
        if (this.fcOpen === true) {
            this.fcOpen = false;
        } else if (this.fcOpen === false) {
            this.fcOpen = true;
        }
    }

}
export interface FcfastpositionOption {
    label?: string;
    href?: string;
}
